<template>
  <b-container>
    <li
      v-for="(eventMapItem, eventName) in message"
      :key="eventName"
      class="list-group-item">
      <span
        v-b-toggle="eventMapItem"
        class="pointer">
        {{ eventName }}
      </span>
      <i
        class="fa fa-times close"
        @click="confirmRemoval({ id: eventName }, () => removeEventMapItem(eventName))" />
      <div class="mt-3">
        <b-form-group
          label-cols="3"
          label="Unentitled Message Key"
          label-class="pt-0">
          <b-form-input v-model="eventMapItem.unentitledMessageKey" />
        </b-form-group>
        <b-form-group
          label-cols="3"
          label="Entitled Message Key"
          label-class="pt-0">
          <b-form-input v-model="eventMapItem.entitledMessageKey" />
        </b-form-group>
      </div>
    </li>
    <b-row align-h="end">
      <b-col
        class="mt-3 mb-3"
        cols="auto">
        <b-button
          variant="outline-primary"
          @click="addEventMapItem">
          Add Event
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConfirmRemoval from '@/mixins/ConfirmRemoval'

export default {
  name: "EventMapVue",
  mixins: [ConfirmRemoval],
  props: {
    message: {
      type: Object,
      default: null,
    },
    messageKey: {
      type: String,
      default: "",
    },
  },
  methods: {
    addEventMapItem() {
      const name = prompt("Please enter a name for the event", "EventKey")
      if (name) {
        this.$emit("add-event-map-item", name)
      }
    },
    removeEventMapItem(eventName) {
      this.$emit("remove-event-map-item", eventName)
    },
  },
}
</script>

<style scoped>

</style>